import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import EntrevistaForm from '../components/Entrevista';

export default function CreateEntrevistaPage() {
  const { idPaciente } = useParams();

  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <EntrevistaForm idPaciente={idPaciente} />
      </Grid>
    </DashboardLayout>
  );
}
